import { ActiveBannerApi } from '@blank/api'
import { BannerMessage } from 'modules/common/components/_ui/BannerMessage/BannerMessage'
import { Button } from 'modules/common/components/_ui/Button/Button'
import { trackEvent } from 'modules/common/lib/amplitude/trackEvent'
import { EnumServicesTrackingEvents } from 'modules/services/lib/tracking/events'

interface Props {
  activeBanner: ActiveBannerApi
}

export const CorporateActiveBanner = ({ activeBanner }: Props) => {
  return (
    <BannerMessage type="danger" className="justify-start">
      <div className="flex items-center justify-between gap-2">
        <div>
          <p className="font-semibold text-danger-900">{activeBanner.title}</p>
          <p className="text-sm text-danger-900">{activeBanner.message}</p>
        </div>
        {activeBanner.cta?.length ? (
          <div className="flex gap-2">
            {activeBanner.cta.map((cta, index) => (
              <Button
                key={`${cta.label}-${index}`}
                onClick={() => {
                  trackEvent({
                    eventType:
                      EnumServicesTrackingEvents.ACTIVE_BANNER_CTA_PRESS,
                  })
                }}
                variant="primary"
                color="default"
                href={cta.url}
                size="small"
              >
                {cta.label}
              </Button>
            ))}
          </div>
        ) : null}
      </div>
    </BannerMessage>
  )
}
